"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneNumber = formatPhoneNumber;
exports.obfuscatePhoneNumber = obfuscatePhoneNumber;
exports.formatDisplayPhoneNumber = formatDisplayPhoneNumber;
function formatPhoneNumber(phoneNumber) {
    const digits = (phoneNumber || '').replace(/[^0-9]/g, '');
    if (digits.length === 10) {
        return '+1' + digits;
    }
    if (digits.length >= 11) {
        return '+' + digits;
    }
    return '';
}
function obfuscatePhoneNumber(phoneNumber) {
    return `(***) ***-**${phoneNumber.substring(phoneNumber.length - 2, phoneNumber.length)}`;
}
function formatDisplayPhoneNumber(unformattedNumber) {
    // Strip all characters from the input except digits
    let rawInput = unformattedNumber.replace(/\D/g, '');
    if (rawInput[0] === '1') {
        rawInput = rawInput.substring(1);
    }
    let formattedInput;
    // Trim the remaining input to ten characters, to preserve phone number format
    formattedInput = rawInput.substring(0, 10);
    // Based upon the length of the string, we add formatting as necessary
    const size = rawInput.length;
    if (size === 0) {
        formattedInput = rawInput;
    }
    else if (size < 4) {
        formattedInput = '+1(' + rawInput;
    }
    else if (size < 7) {
        formattedInput = '+1(' + rawInput.substring(0, 3) + ') ' + rawInput.substring(3, 6);
    }
    else {
        formattedInput = '+1(' + rawInput.substring(0, 3) + ') ' + rawInput.substring(3, 6) + ' - ' + rawInput.substring(6, 10);
    }
    return formattedInput;
}
//# sourceMappingURL=phone.js.map